<template>
	<div class="container">
		<div class="mercNo">
			<div class="no-title">支付宝商户号：</div>
			<div class="no-value">{{alipayMerId}}</div>
		</div>
		<div class="img-div">
			<div class="img-title">保持图片后，在支付宝中识别图片后进入开通流程</div>
			<div class="imgBox">
				<img :src="alipayQrcode" class="imgItem"/>
			</div>
		</div>
		<div class="back-btn">
			<van-button round block color="linear-gradient(to right, #FFCE05, #FBC002)"
			@click="backLastPage">
				返回
			</van-button>
		</div>
	</div>
</template>

<script>
import otherImage from '@/assets/images/upload_other.png'
export default{
	data() {
		return {
			alipayMerId: '',
			alipayQrcode: '',
		}
	},
	mounted() {
		let param = this.$route.query
		this.alipayMerId = param.alipayMerId
		this.alipayQrcode = param.alipayQrcode
	},
	methods: {
		backLastPage(){
			this.$router.back()
		}
	}
}
</script>

<style>
	.mercNo{
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		margin: 10% 3% 0 3%;
		padding: 15px;
		border-radius: 8px;
	}
	.no-title{
		font-family: PingFangSC, PingFang SC;
		color: #333333;;
		font-size: 18px;
		font-weight: 500;
	}
	.no-value{
		font-family: PingFangSC, PingFang SC;
		color: #333333;;
		font-size: 16px;
		font-weight: 500;
	}
	.img-div{
		background: #fff;
		margin: 10% 3% 0 3%;
		padding: 11px;
		border-radius: 8px;
		text-align: center;
	}
	.img-title{
		font-family: PingFangSC, PingFang SC;
		color: #333333;;
		font-size: 15px;
		font-weight: 500;
	}
	.imgBox{
		width: 100%;
	}
	.imgItem{
		width: 100%;
		margin-top: 10px;
	}
	.back-btn {
	  height: 60px;
	  width: 100%;
	  display: flex;
	  justify-content: center;
	  align-items: center;
	  position: fixed;
	  bottom: 10px;
	}
</style>